function transformData<T>(
  data?: { edges?: ({ node: T | null } | null)[] } | null,
): T[] {
  if (data) {
    if (!data.edges || data.edges.length === 0) return [];
    return data.edges.filter(item => !!item?.node).map(({ node }) => node);
  }
  return [];
}

export default transformData;
